import { api } from "./dataService";

export const fetchDocumentTypes = async () => {
  return (await api.get("data/document-types")).data;
};

export const createDocumentType = async (payload) => {
  return (await api.post("data/document-types", payload)).data;
};

export const updateDocumentType = async (document_type_id, payload) => {
  return (await api.patch(`data/document-types/${document_type_id}`, payload)).data;
};

export const deleteDocumentType = async (document_type_id) => {
  await api.delete(`data/document-types/${document_type_id}`);
};

export const reorderDocumentTypes = async (ids) => {
  return (await api.patch("data/document-types/reorder", { ids })).data;
};
